// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { ElevatorFaultMessage, ElevatorFaultMessageT } from './elevator-fault-message';
import { EscalatorFaultMessage, EscalatorFaultMessageT } from './escalator-fault-message';


export enum FaultContent {
  NONE = 0,
  ElevatorFaultMessage = 1,
  EscalatorFaultMessage = 2
}

export function unionToFaultContent(
  type: FaultContent,
  accessor: (obj:ElevatorFaultMessage|EscalatorFaultMessage) => ElevatorFaultMessage|EscalatorFaultMessage|null
): ElevatorFaultMessage|EscalatorFaultMessage|null {
  switch(FaultContent[type]) {
    case 'NONE': return null; 
    case 'ElevatorFaultMessage': return accessor(new ElevatorFaultMessage())! as ElevatorFaultMessage;
    case 'EscalatorFaultMessage': return accessor(new EscalatorFaultMessage())! as EscalatorFaultMessage;
    default: return null;
  }
}

export function unionListToFaultContent(
  type: FaultContent, 
  accessor: (index: number, obj:ElevatorFaultMessage|EscalatorFaultMessage) => ElevatorFaultMessage|EscalatorFaultMessage|null, 
  index: number
): ElevatorFaultMessage|EscalatorFaultMessage|null {
  switch(FaultContent[type]) {
    case 'NONE': return null; 
    case 'ElevatorFaultMessage': return accessor(index, new ElevatorFaultMessage())! as ElevatorFaultMessage;
    case 'EscalatorFaultMessage': return accessor(index, new EscalatorFaultMessage())! as EscalatorFaultMessage;
    default: return null;
  }
}

export type FaultContentT =
  | { type: 'NONE'; value: null }
  | { type: 'ElevatorFaultMessage'; value: ElevatorFaultMessageT }
  | { type: 'EscalatorFaultMessage'; value: EscalatorFaultMessageT };
